module.exports = __webpack_public_path__ + "assets/img/1.d88ca7e3.png";